<app-course-header [courseState]="courseState"></app-course-header>
<div class="px-4">
  <app-course-heading (changeHistory)="changeHistoryDrawer.open()"></app-course-heading>
</div>
<div class="course-intended p-4">
  <div class="card mb-4 block">
    <app-common-tab-menu [items]="tabItems" title="Overview"></app-common-tab-menu>
    <div class="mb-3 h5">
      Activities Breakdown
    </div>
    <div class="sections flex flex-col gap-3">
      @for (section of activity_lists?.results; track section.id; let i = $index) {
        <div class="section-item bg-neutral-50 pb-px"
          [attr.sectionId]="i">
          <ng-container
            *ngTemplateOutlet="sectionHeader; context: { i: i, section: section, active: sectionCollapse[i] }">
          </ng-container>
          <ng-container
            *ngTemplateOutlet="sectionContent; context: { i: i, subsections: section.subsections, active: sectionCollapse[i] }">
          </ng-container>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #sectionHeader let-i="i" let-section="section" let-isActive="active">
  <div class="header flex items-center justify-between rounded-[5px] px-4 py-2" [class.bg-neutral-100]="isActive">
    <div class="left flex items-center gap-3">
      <div class="drag-option">
        <svg-icon src="@assets/images/icons/menu-alt-solid.svg" class="block h-4 w-4"></svg-icon>
      </div>
      <div class="section-number text-sm font-bold">Section {{ i + 1 }}:</div>
      <div class="section-name flex cursor-pointer items-center gap-3" [class.hidden]="sectionEdit[i]">
        <div class="text-sm text-neutral-700">{{section.title}}</div>
      </div>
    </div>
    <div class="right flex items-center gap-3">
      <div class="section-action">
        <button class="btn-transparent btn-sm px-[7px] text-black"
          (click)="sectionCollapse[i] = !sectionCollapse[i]">
          <svg-icon src="@assets/images/icons/chevron-down.svg" class="btn-icon"
            [class.rotate-180]="sectionCollapse[i]">
          </svg-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #sectionContent let-i="i" let-subsections="subsections" let-isActive="active">
  @if (isActive) {
    <div class="content p-5">
      <div class="subsection-items">
        <div class="datagrid-table no_pagination relative">
          <table class="w-full text-left">
            <thead class="heading">
              <tr>
                <th scope="col" class="w-[15%]">
                  <div class="col-name">Lecture Type</div>
                </th>
                <th scope="col" class="w-[40%]">
                  <div class="col-name">Lecture Name</div>
                </th>
                <th scope="col" class="w-[15%]">
                  <div class="col-name">Users who completed</div>
                </th>
                <th scope="col" class="w-[15%]">
                  <div class="col-name">Avg Study Time</div>
                </th>
                <th scope="col" class="w-[15%]">
                  <div class="col-name">Total Study Time</div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (subsection of subsections; track subsection; let i = $index) {
                <tr class="" class="text-left">
                  <td class="">
                    @if (subsection.type==='Article') {
                      <span
                        class="course-id py-0 text-neutral-400 flex items-center gap-2.5">
                        <svg-icon src="@assets/images/icons/book-open.svg" class="w-4 h-4"></svg-icon>
                        Article
                      </span>
                    }
                    @if (subsection.type==='Video') {
                      <span
                        class="course-id py-0 text-neutral-400 flex items-center gap-2.5">
                        <svg-icon src="@assets/images/icons/play-circle-solid.svg" class="w-4 h-4"></svg-icon>
                        Video
                      </span>
                    }
                    @if (subsection.type==='quiz') {
                      <span
                        class="course-id py-0 text-neutral-400 flex items-center gap-2.5">
                        <svg-icon src="@assets/images/icons/puzzle-piece-solid.svg" class="w-4 h-4"></svg-icon>
                        Quiz
                      </span>
                    }
                    @if (subsection.type==='assignment') {
                      <span
                        class="course-id py-0 text-neutral-400 flex items-center gap-2.5">
                        <svg-icon src="@assets/images/icons/clipboard-solid.svg" class="w-4 h-4"></svg-icon>
                        Assignment
                      </span>
                    }
                  </td>
                  <td class="">
                    <span class="course-id py-0"> <span class="font-normal text-slate-600">Lecture</span>
                  {{i+1}}: {{subsection.subsection_type.title}}</span>
                </td>
                <td class="">
                  <span class="course-id py-0">{{subsection.users_have_completed}}</span>
                </td>
                <td class="">
                  <span class="course-id py-0">{{
                  subsection.average_study_time ? subsection.average_study_time : '--'}}</span>
                </td>
                <td class="">
                  <span class="course-id py-0">{{
                  subsection.total_study_time ? subsection.total_study_time : '--'}}</span>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
</ng-template>

<!-- Buyer drawer -->
<app-drawer #changeHistoryDrawer customClass="max-w-[600px] !sm:w-full">
  <ng-container header>
    <div class="px-6 py-5 bg-neutral-50 flex justify-between items-center border-b border-b-neutral-100">
      <h3 class="text-xl text-black font-semibold">Version History</h3>
      <div class="flex justify-between items-center gap-3">
        <button (click)="changeHistoryDrawer.close()" class="bg-neutral-100 rounded-[3px] w-6 h-6">
          <svg-icon src="@assets/images/icons/x-mark.svg" class="text-black w-3 h-3">
          </svg-icon>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container content>
    @if (changeHistoryDrawer.isOpened()) {
      <ng-container content>
        <app-common-history-course maxHeight="90vh"></app-common-history-course>
      </ng-container>
    }
  </ng-container>
</app-drawer>